import { Municipality } from '../interface/Municipality';
import { addMessage } from '../redux/infoMessageSlice';
import { AppDispatch } from '../store/store';

export const getMunicipality = async (
  auth: string,
  dispatch: AppDispatch
): Promise<Municipality | null> => {
  const { REACT_APP_API_URL } = process.env;

  try {
    const response = await fetch(`${REACT_APP_API_URL}/municipality/`, {
      headers: {
        Authorization: auth,
      },
    });

    const data = await response.json();

    if (response.ok) {
      return data[0];
    } else {
      addMessage({ message: 'error.failedToFetch', error: data.message });
      return null;
    }
  } catch (error) {
    dispatch(
      addMessage({
        message: 'error.failedToFetch',
        error: (error as Error).name,
      })
    );
    return null;
  }
};
